import React, { useEffect, Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { useAuth } from "../core/auth/useAuth";
import PageSpinner from "../shared/components/common/PageSpinner";

// Code-split so a logged-out visitor never downloads the authenticated app.
const UnauthenticatedApp = lazy(() =>
  import("../features/auth/components/UnauthenticatedApp"),
);
const AuthenticatedLayout = lazy(() =>
  import("../shared/components/layout/AuthenticatedLayout"),
);

function App() {
  const {
    loginState,
    isActionLoading,
    isLoading,
    handleSignOut,
    currentAuthenticatedUser,
  } = useAuth();

  useEffect(() => {
    currentAuthenticatedUser();
  }, [currentAuthenticatedUser]);

  if (isLoading) {
    return <PageSpinner fullScreen />;
  }

  return (
    <Suspense fallback={<PageSpinner fullScreen />}>
      {loginState.state === "logged_in" ? (
        // Authenticated — all routes go to AuthenticatedLayout;
        <Routes>
          <Route
            path="/*"
            element={
              <AuthenticatedLayout
                handleSignOut={handleSignOut}
                isActionLoading={isActionLoading}
              />
            }
          />
        </Routes>
      ) : (
        <UnauthenticatedApp />
      )}
    </Suspense>
  );
}

export default App;
